import React, { useState, useEffect } from "react";
import { Button } from "../../ButtonElement";
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  Column2,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
  Img,
  ImgWrap,
  ImageCounter,
} from "./InfoElements";

const InfoSection = ({
  showTestimonial,
  isFilterActive,
  lightBg,
  id,
  imgStart,
  topLine,
  lightText,
  headline1,
  headline2,
  headline3,
  darkText,
  description1,
  description2,
  description3,
  description4,
  buttonLabel,
  buttonLabel2,
  buttonLabel3,
  image,
  images,
  backgroundImage,
  showButton,
  showButton2,
  showButton3,
  buttonToPDF,
  buttonLink,
  buttonToPDF2,
  buttonLink2,
  buttonToPDF3,
  buttonLink3,
  alt,
  primary,
  dark,
  dark2,
  showTestimonialButton,
}) => {
    const imageArray = images && images.length ? images : [image];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isFading, setIsFading] = useState(false);

    useEffect(() => {
      if (imageArray.length > 1) {
        const interval = setInterval(() => {
          setIsFading(true);
          setTimeout(() => {
            setCurrentImageIndex((prev) => (prev + 1) % imageArray.length);
            setIsFading(false);
          }, 1000);
        }, 9000);
        return () => clearInterval(interval);
      }
    }, [imageArray.length]);

    const handleButtonClick = (e) => {
      if (buttonToPDF) {
        e.preventDefault();
        window.open(buttonLink, '_blank', 'noopener,noreferrer');
      }
    };

    const handleButtonClick2 = (e) => {
      if (buttonToPDF2) {
        e.preventDefault();
        window.open(buttonLink2, '_blank', 'noopener,noreferrer');
      }
    };

    const handleButtonClick3 = (e) => {
      if (buttonToPDF3) {
        e.preventDefault();
        window.open(buttonLink3, '_blank', 'noopener,noreferrer');
      }
    };

  return (
    <>
      <InfoContainer backgroundImage={backgroundImage} isFilterActive={isFilterActive} lightBg={lightBg} id={id}>
        <InfoWrapper>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <TopLine>{topLine}</TopLine>
                <Heading lightText={lightText}>{headline1}</Heading>
                <Subtitle darkText={darkText}>{description1}</Subtitle>
                <Heading lightText={lightText}>{headline2}</Heading>
                <Subtitle darkText={darkText}>{description2}</Subtitle>
                <Heading lightText={lightText}>{headline3}</Heading>
                <Subtitle darkText={darkText}>{description3}</Subtitle>
                <Subtitle darkText={darkText}>{description4}</Subtitle>
                {(showButton || showButton2 || showButton3) && <BtnWrap>
                  {showButton && (
                    <Button
                      onClick={handleButtonClick}
                      to={buttonLink}
                      smooth="true"
                      duration={500}
                      spy="true"
                      exact="true"
                      offset={-80}
                      primary={primary ? 1 : 0}
                      dark={dark ? 1 : 0}
                      dark2={dark2 ? 1 : 0}
                    >
                      {buttonLabel}
                    </Button>
                  )}
                  {showButton2 && (
                    <Button
                      onClick={handleButtonClick2}
                      to={buttonLink2}
                      smooth="true"
                      duration={500}
                      spy="true"
                      exact="true"
                      offset={-80}
                      primary={primary ? 1 : 0}
                      dark={dark ? 1 : 0}
                      dark2={dark2 ? 1 : 0}
                    >
                      {buttonLabel2}
                    </Button>
                  )}
                  {showButton3 && (
                    <Button
                      onClick={handleButtonClick3}
                      to={buttonLink3}
                      smooth="true"
                      duration={500}
                      spy="true"
                      exact="true"
                      offset={-80}
                      primary={primary ? 1 : 0}
                      dark={dark ? 1 : 0}
                      dark2={dark2 ? 1 : 0}
                    >
                      {buttonLabel3}
                    </Button>
                  )}
                </BtnWrap>}
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={imageArray[currentImageIndex]} alt={alt} isFading={isFading} />
                <ImageCounter>
                  {currentImageIndex + 1} / {imageArray.length}
                </ImageCounter>
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default InfoSection;
